import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { PricingFormItem } from "./PricingForm"
import {
    Pricing,
    PricingLocationSaveRequestData,
    PricingOverride,
    PricingResponse,
    PricingSaveRequestData,
    PricingSortRequestData,
    PricingType,
} from "../../../../graphql/types"

export const PRICING_FORM_SUBMITTED = "pricing/form/submitted"

export const pricingFormSubmitted = (oldValue: Maybe<PricingFormItem>, newValue: PricingFormItem) => ({
    type: PRICING_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const DELETE_PRICING_CLICKED = "pricing/delete/clicked"

export const deletePricingClicked = (id: string, pricingType: PricingType) => ({
    type: DELETE_PRICING_CLICKED,
    payload: {
        pricingId: id,
        pricingType: pricingType,
    },
})

export const CLOSE_PRICING_FORM_CLICKED = "pricing/close/clicked"

export const closePricingFormClicked = () => ({
    type: CLOSE_PRICING_FORM_CLICKED,
})

export const PRICING_MOVED = "PRICING_MOVED"

export const pricingMoved = (pricingId: string, newSortIndex: number) => {
    return {
        type: PRICING_MOVED,
        payload: {
            pricingId: pricingId,
            newSortIndex: newSortIndex,
        },
    }
}

export const FETCH_SPECIAL_PRICINGS_SUCCESS = "fetchSpecialPricings/success"

export const fetchSpecialPricingsSuccess = (pricingResponse: PricingResponse) => ({
    type: FETCH_SPECIAL_PRICINGS_SUCCESS,
    payload: {
        pricingResponse: pricingResponse,
    },
})

export const FETCH_SPECIAL_PRICINGS_FAILURE = "fetchSpecialPricings/failure"

export const fetchSpecialPricingsFailure = (error?: Maybe<any>) => ({
    type: FETCH_SPECIAL_PRICINGS_FAILURE,
    payload: {
        error: error,
    },
})
// Api actions

export const PRICING_SAVE_REQUESTED = "pricing/save/requested"

export const pricingSaveRequested = (data: PricingSaveRequestData) => ({
    type: PRICING_SAVE_REQUESTED,
    payload: {
        data: data,
    },
})

export const PRICING_SAVE_SUCCESS = "pricing/save/success"

export const pricingSaveSuccess = (data: Pricing) => ({
    type: PRICING_SAVE_SUCCESS,
    payload: {
        data: data,
    },
})

export const PRICING_SAVE_FAILURE = "pricing/save/failure"

export const pricingSaveFailure = (error: any) => ({
    type: PRICING_SAVE_FAILURE,
    payload: {
        error: error,
    },
})

export const PRICING_LOCATION_SAVE_REQUESTED = "pricing/location/save/requested"

export const pricingLocationSaveRequested = (data: PricingLocationSaveRequestData, locationId: string) => ({
    type: PRICING_LOCATION_SAVE_REQUESTED,
    payload: {
        data: data,
        locationId: locationId,
    },
})

export const PRICING_LOCATION_SAVE_SUCCESS = "pricing/location/save/success"

export const pricingLocationSaveSuccess = (
    data: Maybe<PricingOverride>,
    saveRequestData: Maybe<PricingLocationSaveRequestData>,
    locationId: string
) => ({
    type: PRICING_LOCATION_SAVE_SUCCESS,
    payload: {
        data: data,
        saveRequestData: saveRequestData,
        locationId: locationId,
    },
})

export const PRICING_LOCATION_SAVE_FAILURE = "pricing/location/save/failure"

export const pricingLocationSaveFailure = (error: any) => ({
    type: PRICING_LOCATION_SAVE_FAILURE,
    payload: {
        error: error,
    },
})

export const PRICING_SORT_REQUESTED = "pricing/sort/requested"

export const pricingSortRequested = (data: PricingSortRequestData) => ({
    type: PRICING_SORT_REQUESTED,
    payload: {
        data: data,
    },
})

export const REFETCH_PRICINGS_DATA = "pricing/refetch-data"
export const refetchPricingsData = () => ({
    type: REFETCH_PRICINGS_DATA,
})
